import * as React from 'react';
import SwitchAccountsModal from 'components/switchAccountsModal';
import strings from 'utils/strings';
import { killEvent } from 'utils/domUtils';
import { buildClassString, replaceTokens } from '@ps/payscale-shared-ui/lib/StringUtils';
import './accountPicker.scss';

interface AccountPickerProps {
    accounts: MasterAccountDictionary;
    currentAccountId: string;
    currentAccountDetails?: MasterAccount;
    onAccountChange?: (accountId: string) => void;
    userCount: number | null;
}

interface AccountPickerState {
    showModal: boolean;
}

class AccountPicker extends React.PureComponent<AccountPickerProps, AccountPickerState> {

    constructor(props: AccountPickerProps) {
        super(props);
        this.state = Object.assign({}, this.state, { showModal: false });

        this._showModal = this._showModal.bind(this);
        this._hideModal = this._hideModal.bind(this);
    }

    render(): React.ReactNode {
        const { currentAccountId, accounts, userCount, onAccountChange, currentAccountDetails } = this.props;
        const { showModal } = this.state;
        const allowSwitchAccounts = Object.keys(accounts).length > 1;
        const account = accounts[currentAccountId];

        const userCountClassString = buildClassString({
            'account-picker__current-account__user-count': true,
            'hidden': userCount === null
        });
        return (
            <div className="account-picker">
                <div className="account-picker__current-account">
                    <div className="account-picker__current-account__name">
                        {account ? account.name : ''}
                    </div>
                    <div className={userCountClassString}>
                        {replaceTokens(strings.totalUserCount, userCount || 0)}
                    </div>
                    {
                        currentAccountDetails?.samlPartnerId ?
                            <div className="account-picker__current-account__saml">
                                {strings.samlControlledAccount}
                            </div> : null
                    }
                </div>
                { allowSwitchAccounts &&
                    <a href="#" className="account-picker__switch-account" onClick={this._showModal}>
                        {strings.switchAccount}
                    </a>
                }
                { allowSwitchAccounts &&
                    <SwitchAccountsModal
                        accounts={accounts}
                        currentAccountId={currentAccountId}
                        show={showModal}
                        onHide={this._hideModal}
                        onCommit={onAccountChange}
                    />
                }
            </div>
        );
    }

    private _showModal(e?: React.SyntheticEvent<HTMLElement>): void {
        if (e) {
            killEvent(e);
        }

        this.setState({ showModal: true });
    }

    private _hideModal(): void {
        this.setState({ showModal: false });
    }
}

export { AccountPicker };
export default AccountPicker;



// WEBPACK FOOTER //
// ./src/components/accountPicker.tsx